import React from 'react';

import { func_validation, func_cookieSetting, func_datetime } from 'functions';

export const generalInvoicesColumns = {
    // Columns Array
    getColumns,

    // Columns
    getColumns_accountCode,
    getColumns_invoiceID,
    getColumns_SqlAccountInvoiceNo,
    getColumns_date,
    getColumns_amount,
    getColumns_lastSentEmail,
    getColumns_documentDate,
}

function getColumns() {
    return [
        getColumns_invoiceID(),
        getColumns_SqlAccountInvoiceNo(),
        // getColumns_accountCode(),
        getColumns_date(),
        getColumns_documentDate(),
        // getColumns_lastSentEmail(),
        getColumns_amount(),
    ];
}

function getColumns_accountCode() {
    let columnClassName = "distributorPortal-generalInvoices-tableColumn-accountCode";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Account Code",
        id: "accountCode",
        accessor: "AccountCode",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
        width: 115,
    }
}

function getColumns_invoiceID() {
    let columnClassName = "distributorPortal-generalInvoices-tableColumn-invoiceID";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Proforma Invoice ID",
        id: "invoiceID",
        accessor: "Id",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isNumberValid(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
        width: 130,
    }
}

function getColumns_SqlAccountInvoiceNo() {
    let columnClassName = "distributorPortal-generalInvoices-tableColumn-sqlAccountInvoiceNo";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Invoice ID",
        id: "sqlAccountInvoiceNo",
        accessor: "ReferenceDocumentNo",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
        width: 115,
    }
}

function getColumns_date() {
    let columnClassName = "distributorPortal-generalInvoices-tableColumn-issueDate";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Issue Date",
        // isHeaderColumnSortable: true,
        // sortValue: "issueDate"
        id: "issueDate",
        accessor: "IssueDateTime",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";
            if (func_validation.isStringTrimNotEmpty(value_formatted) && (value_formatted != "-")) 
                value_formatted = func_datetime.convertDateTimeToLocal(value_formatted, "DD/MM/YYYY");

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
        width: 115,
    }
}

function getColumns_amount() {
    let columnClassName = "distributorPortal-generalInvoices-tableColumn-subtotal";

    return {
        headerCellClassName: columnClassName + " justify-content-start",
        Header: "SubTotal (RM)",
        // isHeaderColumnSortable: true,
        // sortValue: "subTotal"
        id: "subTotal",
        accessor: "SubTotal",
        bodyCellClassName: columnClassName + " justify-content-end",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isNumberValid(value)? value: "-";
            if (value_formatted != "-")
                value_formatted = func_cookieSetting.getFormattedPrice(value_formatted, { currencyDisabled: true });

            return (
                <div className={"noWrap-text-ellipsis "}>{value_formatted}</div>
            );
        },
        width: 115,
    }
}

function getColumns_lastSentEmail() {
    let columnClassName = "distributorPortal-generalInvoices-tableColumn-lastSentEmail";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Last Sent Email",
        // isHeaderColumnSortable: true,
        // sortValue: "lastSentEmail"
        id: "lastSentEmail",
        accessor: "LastSendEmail",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";
            if (func_validation.isStringTrimNotEmpty(value_formatted) && (value_formatted != "-")) 
                value_formatted = func_datetime.convertDateTimeToLocal(value_formatted, "DD/MM/YYYY");

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
        width: 115,
    }
}

function getColumns_documentDate() {
    let columnClassName = "distributorPortal-generalInvoices-tableColumn-documentDate";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Document Date",
        // isHeaderColumnSortable: true,
        // sortValue: "documentDate"
        id: "documentDate",
        accessor: "DocumentDateTime",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";
            if (func_validation.isStringTrimNotEmpty(value_formatted) && (value_formatted != "-")) 
                value_formatted = func_datetime.convertDateTimeToLocal(value_formatted, "DD/MM/YYYY");

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
        width: 115,
    }
}